export class TreasuryFundRequestContractError extends Error {
  constructor(operation, detail) {
    super(`Invalid Treasury fund ${operation} request: ${detail}`);
    this.name = 'TreasuryFundRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const isText = value => value === null || typeof value === 'string';
const decimal = value => typeof value === 'number'
  || typeof value === 'string' && /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(value.trim());
const positiveAmount = value => decimal(value) && Number.isFinite(Number(value)) && Number(value) > 0;
const donationFields = [
  'isAcceptingContributions', 'visibility', 'suggestedAmounts', 'suggestedCurrency',
  'instructions', 'contactEmail', 'externalUrl', 'referenceLabel', 'referenceHint',
];
const donationTextFields = [
  'suggestedCurrency', 'instructions', 'contactEmail', 'externalUrl', 'referenceLabel', 'referenceHint',
];

export function readFundReconciliationReviewRequest(payload) {
  if (!isRecord(payload) || typeof payload.status !== 'string'
    || !['unreviewed', 'reviewed', 'reconciled'].includes(payload.status.trim())
    || (payload.note !== undefined && !isText(payload.note))) {
    throw new TreasuryFundRequestContractError('reconciliation review', 'expected a valid status and optional text note.');
  }
  return payload;
}

export function readFundDonationConfigRequest(payload) {
  if (!isRecord(payload) || !donationFields.some(field => field in payload)
    || (payload.isAcceptingContributions !== undefined && typeof payload.isAcceptingContributions !== 'boolean')
    || (payload.visibility !== undefined && (typeof payload.visibility !== 'string'
      || !['internal', 'community', 'public'].includes(payload.visibility.trim())))
    || (payload.suggestedAmounts !== undefined && (!Array.isArray(payload.suggestedAmounts)
      || !payload.suggestedAmounts.every(positiveAmount)))
    || donationTextFields.some(field => payload[field] !== undefined && !isText(payload[field]))) {
    throw new TreasuryFundRequestContractError('donation configuration', 'expected valid visibility, amounts and text fields.');
  }
  return payload;
}

export function readFundReference(value) {
  if (typeof value !== 'string' || !value.trim()) {
    throw new TreasuryFundRequestContractError('reference', 'expected a nonempty fund id, code or name.');
  }
  return value;
}

export function readFundCreateRequest(payload) {
  if (!isRecord(payload) || typeof payload.code !== 'string' || !payload.code.trim()
    || !['fundName', 'name', 'currency', 'description'].every(key => payload[key] === undefined || isText(payload[key]))
    || typeof (payload.fundName || payload.name) !== 'string' || !(payload.fundName || payload.name).trim()
    || payload.currency !== undefined && payload.currency !== null && !payload.currency.trim()
    || !decimal(payload.balance) || !Number.isFinite(Number(payload.balance)) || Number(payload.balance) < 0) {
    throw new TreasuryFundRequestContractError('create', 'expected code, name, typed optional text and non-negative balance.');
  }
  return payload;
}
